export default __webpack_public_path__ + "static/cert-4-8852c5b40ece95fe3204a9bdf9473e5e.png";